/**
 * 클립보드 복사 헬퍼 — 인앱 브라우저 호환.
 *
 * 네이버·카카오 인앱 브라우저 등에서는 Clipboard API가 없거나 권한이 거부될 수 있다.
 * 이때 execCommand 폴백을 시도하고, 어떤 경우에도 예외를 던지지 않고 성공 여부만 반환한다
 * (미보호 writeText는 unhandledrejection으로 에러 로그를 오염시킨다 — 2026-07-05).
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    // Clipboard API 거부 — execCommand 폴백 시도
  }
  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(textarea)
    return ok
  } catch {
    return false
  }
}
